import { Patient } from '../../../dPpatients/vue/Classes/Patient'
import ResourceType from '../../../dPbloc/vue/Classes/ClvrResourceType'
import { User } from '../../../admin/vue/classes/User'
import { UserGenericTypes } from '../../../admin/vue/enums/UserGenericTypes'
import AnesthesiaType from '../../../dPplanningOp/vue/Classes/ClvrAnesthesiaType'
import HospitalRoom from '../../../dPhospi/vue/Classes/ClvrHospitalRoom'
import { OperationTimeStatusEnum } from '../../../dPplanningOp/vue/Enum'
import Operation from '../../../dPplanningOp/vue/Classes/ClvrOperation'
import { add, format } from 'date-fns'
import Staff from '../../../dPpersonnel/vue/Classes/Staff'
import { EnumStaffRole } from '../../../dPpersonnel/vue/Enum'
import Stay from '../../../dPplanningOp/vue/Classes/Stay'
import Bed from '../../../dPhospi/vue/Classes/ClvrBed'
import Room from '../../../dPbloc/vue/Classes/ClvrRoom'
import Service from '../../../dPhospi/vue/Classes/ClvrService'
import Affectation from '../../../dPhospi/vue/Classes/ClvrAffectation'
import AdmissionType from '../../../dPplanningOp/vue/Classes/ClvrAdmissionType'
import CommonHelper from '../../../system/vue/Classes/CommonHelper'

export default class ScreenControlFakeData {
    private static lastNames = ['Dupont', 'Martin', 'Bernard', 'Thomas', 'Petit', 'Wolfeschlegelsteinhausenbergerdorff']
    private static maleFirstNames = ['Lucas', 'Louis', 'Gabriel', 'Arthur', 'Jules', 'Jean-pierre-marie-joseph']
    private static femaleFirstNames = ['Emma', 'Louise', 'Alice', 'Chloé', 'Lina', 'Anne-marie louise']
    private static resourceLabels = ['scalpel', 'forceps', 'sutures']
    private static operationLabels = [
        'Amputation de la jambe',
        'Appendicectomie',
        'Chirurgie cardiaque',
        'Greffes de peau',
        'Réparation de fracture',
        'Amputation de la jambe avec réadaptation fonctionnelle et gestion de la douleur pour une récupération optimale',
        'Appendicectomie par laparoscopie, une intervention minimale pour retirer l’appendice enflammé',
        'Chirurgie cardiaque ouverte pour la correction de défauts cardiaques complexes, y compris les remplacements de valve et les réparations aortiques',
    ]
    private static operationRemarks = [
        'Assurons-nous que tous les équipements nécessaires sont prêts et fonctionnels.',
        'Vérifiez les allergies du patient une dernière fois avant de commencer.',
        "Le patient semble anxieux, envisagez d'administrer un sédatif léger.",
        "Confirmez le site opératoire avec l'équipe et marquez-le clairement.",
        "Révisez le plan opératoire avec l'équipe pour éviter toute confusion.",
        'Le patient a été correctement informé des risques et a signé le consentement.',
        'Assurez-vous que les résultats des derniers tests préopératoires sont dans le dossier.',
        "Vérifiez que l'anesthésiste est prêt et que le monitoring est en place.",
        'Confirmez la disponibilité de sang pour transfusion si nécessaire.',
        "Faites un dernier point rapide avec l'équipe pour répondre à toutes les questions.",
    ]
    private static operationMaterial = [
        'Scalpel stérile',
        'Pinces hémostatiques',
        'Sutures',
        'Champs opératoires',
        'Gants chirurgicaux',
        'Masques faciaux',
        'Lunettes de protection',
        'Draps chirurgicaux stériles',
        'Aspirateur chirurgical',
        'Lampes opératoires',
    ]
    private static anesthesiaTypes = [
        'Anesthésie générale',
        'Anesthésie locale',
        'Anesthésie régionale',
        'Sédation intraveineuse',
        'Anesthésie péridurale',
        'Anesthésie rachidienne',
    ]

    private static services: string[] = [
        'Urgences',
        'Chirurgie',
        'Pédiatrie',
        'Gynécologie',
        'Cardiologie',
        'Neurologie',
        'Radiologie',
        'Anesthésie',
        'Réanimation',
        'Psychiatrie',
        'Urologie',
    ]

    private static admissions: string[] = ['Hospitalisation complète', 'Ambulatoire', 'Consultation', 'Urgent']

    private static isolationTypes = ['aucun', 'air', 'contact', 'gouttelette']

    public static createFakeData(max = 1): Operation[] {
        const fakeData: Operation[] = []

        for (let i = 0; i < max; i++) {
            const date = this.createFakeDate()

            const operation = new Operation({
                id: null,
                surgeonId: null,
                stayId: null,
                roomId: null,
                date: format(date, 'yyyy-MM-dd'),
                timeOperation: this.createFakeOperationTime(),
                label: this.createFakeOperationLabel(),
                materials: this.createFakeOperationMaterial(),
                remarks: this.createFakeOperationRemark(),
                room: this.createFakeRoom(),
                patient: this.createFakePatient(),
                additionalMaterials: this.createFakeStuff(),
                surgeon: this.createFakeUser(),
                anesthetist: this.createFakeUser(),
                anesthesiaType: this.createFakeAnesthesiaTypes(),
                operationTimeStatus: this.createFakeOperationTimeStatus(),
                staffs: this.createFakeStaff(),
                stay: this.createFakeStay(),
                emergency: this.createFakeEmergency(),
                cancelled: this.createFakeEmergency(),
            })
            operation.startOperation = format(date, 'HH:mm:ss')
            fakeData.push(operation)
        }
        return fakeData
    }

    private static createFakeHuman() {
        const sex = Math.random() > 0.5 ? 'M' : 'F'
        const lastName = this.getRandomElementFromList(this.lastNames)
        const firstName =
            'M' === sex
                ? this.getRandomElementFromList(this.maleFirstNames)
                : this.getRandomElementFromList(this.femaleFirstNames)
        const title = 'M' === sex ? 'M' : 'Mme'
        const id = Math.floor(Math.random() * 1000)
        const birthDate = `${Math.floor(Math.random() * (2003 - 1920)) + 1920}-${Math.floor(Math.random() * 12) + 1}-${
            Math.floor(Math.random() * 28) + 1
        }`

        return {
            id,
            sex,
            lastName,
            firstName,
            title,
            birthDate,
        }
    }

    private static createFakePatient(): Patient {
        const human = this.createFakeHuman()

        return new Patient(
            human.id,
            human.lastName,
            '',
            human.firstName,
            '',
            '',
            '',
            human.birthDate,
            human.sex,
            human.title,
        )
    }

    private static createFakeUser(): User {
        const human = this.createFakeHuman()

        const userUsername = `${human.firstName} ${human.lastName}`

        return new User({
            id: human.id,
            userUsername: userUsername,
            userPassword: '',
            userFirstName: human.firstName,
            userLastName: human.lastName,
            userType: UserGenericTypes.DOCTOR,
            color: CommonHelper.randomColor,
        })
    }

    private static createFakeListUser(min = 1, max = 1): User[] {
        const users: User[] = []
        for (let i = min; i <= max; i++) {
            users.push(this.createFakeUser())
        }
        return users
    }

    private static createFakeStuff(min = 0): ResourceType[] {
        if (min < 0) {
            return []
        }
        const numberOfResources = Math.floor(Math.random() * 3)
        const resources: ResourceType[] = []

        for (let i = min; i < numberOfResources; i++) {
            const label = this.getRandomElementFromList(this.resourceLabels)
            const resource = new ResourceType({ id: Math.floor(Math.random() * 1000), label: label })
            resources.push(resource)
        }

        return resources
    }

    private static createFakeRoom(): Room {
        const id = Math.floor(Math.random() * 3) + 1

        return new Room({
            id: id,
            roomOperationId: null,
            name: `salle ${id}`,
        })
    }

    private static createFakeOperationLabel(): string {
        return this.getRandomElementFromList(this.operationLabels)
    }

    private static createFakeOperationRemark(): string {
        return this.getRandomElementFromList(this.operationRemarks)
    }

    private static createFakeOperationMaterial(): string {
        return this.getRandomElementFromList(this.operationMaterial)
    }

    private static createFakeAnesthesiaTypes(): AnesthesiaType {
        return new AnesthesiaType({
            id: Math.random() * 20,
            name: this.getRandomElementFromList(this.anesthesiaTypes),
        })
    }

    private static createFakeDate(): Date {
        const daysToAdd = Math.floor(Math.random() * 31)
        const hoursToAdd = Math.floor(Math.random() * 24)
        return add(new Date(), { days: daysToAdd, hours: hoursToAdd })
    }

    private static createFakeOperationTime(): string {
        const hours = Math.floor(Math.random() * 3)

        const minutesOptions = [0, 15, 30, 45]
        let minutes = minutesOptions[Math.floor(Math.random() * minutesOptions.length)]
        if (0 === hours && 0 === minutes) {
            minutes = minutesOptions[1]
        }
        return `${hours}:${minutes}:00`
    }

    private static createFakeOperationTimeStatus(): OperationTimeStatusEnum {
        const statusValues = Object.values(OperationTimeStatusEnum)
        const randomIndex = Math.floor(Math.random() * statusValues.length)
        return statusValues[randomIndex]
    }

    private static createFakeStaff(max = 3): Staff[] {
        const roles: EnumStaffRole[] = [
            EnumStaffRole.INSTRUMENTALIST,
            EnumStaffRole.ROOM_HELPER,
            EnumStaffRole.NURSE_ANESTHETIST,
        ]
        const list: Staff[] = []
        roles.forEach(role => {
            for (let i = 0; i < Math.floor(Math.random() * (max + 1)); i++) {
                list.push(
                    new Staff({
                        id: null,
                        userId: null,
                        user: this.createFakeUser(),
                        role: role,
                    }),
                )
            }
        })
        return list
    }

    private static createFakeStay(): Stay {
        return new Stay({
            id: null,
            patientId: null,
            praticienId: null,
            groupId: null,
            serviceId: null,
            type: '',
            entreePrevue: '',
            sortiePrevue: '',
            isolationType: this.getRandomElementFromList(this.isolationTypes),
            admissionType: this.createFakeAdmissionType(),
            currentAffectation: this.createFakeAffectation(),
        })
    }

    private static createFakeAdmissionType(): AdmissionType {
        return new AdmissionType({
            id: null,
            label: this.getRandomElementFromList(this.admissions),
        })
    }

    private static createFakeAffectation(): Affectation {
        return new Affectation({
            id: null,
            bedId: null,
            serviceId: null,
            bed: this.createFakeBed(),
            service: this.createFakeService(),
        })
    }

    private static createFakeBed(): Bed {
        return new Bed({
            id: null,
            hospitalRoomId: null,
            name: this.createFakeCode(),
            hospitalRoom: this.createFakeHospitalRoom(),
        })
    }

    private static createFakeHospitalRoom(): HospitalRoom {
        return new HospitalRoom({
            id: null,
            name: `Chambre ${this.createFakeNumberCode()}`,
        })
    }

    private static createFakeNumberCode(): string {
        return `${Math.floor(Math.random() * 900) + 100}`
    }

    private static createFakeCode(): string {
        const letter = String.fromCharCode(65 + Math.floor(Math.random() * 4))
        return `${this.createFakeNumberCode}${letter}`
    }

    private static createFakeService(): Service {
        return new Service({
            id: null,
            groupId: null,
            name: this.getRandomElementFromList(this.services),
        })
    }

    private static createFakeEmergency(): boolean {
        return Math.random() < 0.3
    }

    private static getRandomElementFromList(list: string[]): string {
        return list[Math.floor(Math.random() * list.length)]
    }
}
